import React from 'react'
import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import GallerySection from '../components/GallerySection'

export default function PrivateCleaning() {
  const pageImage = 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=85,format=auto/assets/8bec77d8-9a30-4008-bc94-797ed827a99a/privat-cleaning-home.jpg'

  return (
    <div>
      <MetaTags
        title="Privat rengøring - Elses skrub og skur"
        description="Skræddersyet privat rengøring i Skjern. Få et rent og frisk hjem med min grundige rengøringsservice tilpasset dine ønsker."
      />

      {/* Hero Header */}
      <section className="bg-[#FAF9F5] min-h-[90vh] flex items-center py-12 lg:py-16 border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            
            <div className="lg:col-span-7 space-y-5">
              <span className="text-xs font-bold uppercase tracking-wider text-[#3A684D] bg-[#EEF4F0] px-3.5 py-1.5 rounded-full inline-block border border-[#D2E0D6]">
                Privat Rengøring
              </span>
              
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif-display font-bold text-[#285F41] tracking-tight leading-tight">
                Grundig og tryg rengøring af dit hjem i Skjern
              </h1>

              <p className="text-base sm:text-lg text-[#4A5D50] leading-relaxed">
                Elses skrub og skur tilbyder privat rengøringsservice tilpasset dine ønsker og din tidsplan. Jeg behandler dit hjem med respekt og sørger for et rent, frisk og behageligt indeklima.
              </p>

              <div className="flex flex-wrap items-center gap-4 pt-2">
                <a
                  href="tel:52506794"
                  className="contact-no-break inline-flex items-center gap-2.5 px-6 py-3.5 rounded-xl bg-[#285F41] text-white font-semibold text-sm shadow-md hover:bg-[#357753] transition-all"
                >
                  <i className="fa-solid fa-phone text-emerald-300" aria-hidden="true"></i>
                  <span>Ring på 52 50 67 94</span>
                </a>

                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-white text-[#285F41] font-semibold text-sm border border-[#D2E0D6] hover:bg-[#EEF3EF] transition-all"
                >
                  <span>Kontakt mig om privatrengøring</span>
                  <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl overflow-hidden border border-[#D5E1D8] shadow-xl">
                <img
                  src={pageImage}
                  alt="Ren og hyggelig privat bolig i Skjern"
                  className="w-full h-[420px] sm:h-[480px] lg:h-[560px] object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Main Content Info */}
      <section className="py-16 bg-white border-b border-[#E2E7E2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="max-w-3xl mx-auto text-center space-y-3">
            <h2 className="text-2xl sm:text-3xl font-serif-display font-bold text-[#285F41]">
              En nemmere hverdag med privat rengøringshjælp
            </h2>
            <p className="text-sm text-[#4A5D50] leading-relaxed">
              Uanset om du ønsker fast rengøring i hverdagen eller hjælp i forbindelse med særlige behov, står jeg klar med en grundig og lokal indsats.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 [&>:last-child]:md:col-span-2 [&>:last-child]:lg:col-span-1">
            
            <div className="bg-[#FAF9F5] p-6 rounded-2xl border border-[#D9E3DC] space-y-3">
              <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg">
                <i className="fa-regular fa-broom" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#285F41]">
                Aftørring &amp; Støvsugning
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Aftørring af frie flader, støvsugning af tæpper og gulve samt omhyggelig gulvvask i hjemmets rum.
              </p>
            </div>

            <div className="bg-[#FAF9F5] p-6 rounded-2xl border border-[#D9E3DC] space-y-3">
              <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg">
                <i className="fa-regular fa-sink" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#285F41]">
                Køkken &amp; Bad
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Grundig rengøring af badeværelse, toilet, vaske og overflader i køkkenet for høj hygiejne.
              </p>
            </div>

            <div className="bg-[#FAF9F5] p-6 rounded-2xl border border-[#D9E3DC] space-y-3">
              <div className="w-10 h-10 rounded-xl bg-[#EEF4F0] text-[#285F41] flex items-center justify-center text-lg">
                <i className="fa-regular fa-handshake" aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#285F41]">
                Pålidelig &amp; Diskret
              </h3>
              <p className="text-xs text-[#4A5D50] leading-relaxed">
                Du kan trygt overlade nøglen og rengøringen til mig – jeg overholder altid indgåede aftaler.
              </p>
            </div>

          </div>

          {/* Callout box */}
          <div className="bg-[#285F41] text-white p-8 rounded-2xl flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="space-y-2 text-center sm:text-left">
              <h3 className="text-xl font-bold">Har du spørgsmål til privat rengøring?</h3>
              <p className="text-xs text-[#C2D6CA]">
                Ring eller send en e-mail i dag for en uforpligtende snak om, hvordan jeg bedst kan hjælpe dig.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 shrink-0">
              <a
                href="tel:52506794"
                className="contact-no-break px-5 py-3 rounded-xl bg-white text-[#285F41] font-semibold text-xs hover:bg-[#EEF3EF] transition-colors"
              >
                Ring: 52 50 67 94
              </a>
              <a
                href="mailto:else_christiansen@godmail.dk"
                className="contact-no-break px-5 py-3 rounded-xl bg-[#357753] text-white font-semibold text-xs border border-[#488B66] hover:bg-[#3D855D] transition-colors"
              >
                Send e-mail
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* DYNAMIC CMS GALLERY */}
      <GallerySection
        reference="privat-rengoering"
        title="Billeder fra privat rengøring"
        description="Se eksempler på mit rengøringsarbejde i private boliger."
      />

    </div>
  )
}
